{
  "version": "0.2.0",
  "gitCommitHash": "98921427c39c809f3dfa2505b83e5824f7d61028",
  "gitCommitShortHash": "9892142",
  "gitBranch": "HEAD",
  "gitTags": "",
  "clean": true
}